import React, { useState } from 'react';
import { Check, Close } from '@gjensidige/builders-icons';
import { Text, Expandable } from '@gjensidige/builders-components';

import './CoverageList.scss';
import { Coverage } from '../../interfaces/Types';
import tracker from '../../tracking';

interface ICoverageData {
  coverages: Coverage[];
  includedCoverage?: boolean;
  isPlusPacket?: boolean;
}

export const CoverageList: React.FC<ICoverageData> = (props: ICoverageData) => {
  const [selectedCoverage, setSelectedCoverage] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  // const setExpandedCoverage = (event: any) => {
  //   setSelectedCoverage(event.currentTarget.dataset.coverage);
  // };

  const toggleClick = (isPanelExpanded: boolean, label: string) => {
    /***
      Custom tracking as the builders component version used in the app does not track scenario label and steps.
      Fix for https://gjensidige.atlassian.net/browse/SE-6433
      TODO: Remove the custom tracking once we migrated to new builders-components, if it supports the desired tracking.
    ***/
    tracker.trackEvent(
      {
        eventAction: isPanelExpanded ? 'expand' : 'minimize',
        eventCategory: 'expandable',
        eventKey: 'interact',
        eventLabel: label
      }
    )
    setIsExpanded(isPanelExpanded);
    setSelectedCoverage(label);
  };
  function createMarkup(text: string) {
    return { __html: text };
  }
  return (
    <>
      {props.coverages &&
        props.coverages.map((coverage, index) => {
          return (
            <React.Fragment
              key={index}
            >
              <Expandable
                variant={props.includedCoverage ? "line-blue-yellow" : "line-white-yellow"}
                open={selectedCoverage === coverage.name && isExpanded}
                onChange={(isOpen) => toggleClick(isOpen, coverage.name)}
                tracking={false}
                className="coverage-expandable"
              >
                <Expandable.Title className="included-coverage-item">
                  <div className="coverage-header-wrapper">
                    {props.includedCoverage ? (
                      <Check
                        className="included-coverage-icon"
                        width="16px"
                        height="16px"
                      />
                    ) : (
                      <Close
                        className="included-coverage-icon"
                        width="16px"
                        height="16px"
                      />
                    )}
                    <Text size="body" className={`${props.isPlusPacket ? 'coverage-pluspaket' : ''} included-coverage-item pl-2`}>
                      {coverage.name}
                    </Text>
                  </div>
                </Expandable.Title>
                <Expandable.Content>
                  <>
                    {coverage.description.length > 0 &&
                      coverage.description.map(
                        (descriptionList: any, index: number) => {
                          return (
                            <div key={index} className="pl-2 pb-1">
                              <Text size="body">{descriptionList.title}</Text>
                              {descriptionList.details
                                .split('\n')
                                .map((text: string, index: number) => {
                                  return (
                                    <div
                                      className={
                                        text.trim().length > 0 ? '' : 'pt-1'
                                      }
                                      key={index}
                                      dangerouslySetInnerHTML={createMarkup(
                                        text
                                      )}
                                    ></div>
                                  );
                                })}
                            </div>
                          );
                        }
                      )}
                  </>
                </Expandable.Content>
              </Expandable>
            </React.Fragment>
          );
        })}
    </>
  );
};
